import { render, staticRenderFns } from "./OpinionPublishProcess.vue?vue&type=template&id=7c5229ad&scoped=true&"
import script from "./OpinionPublishProcess.vue?vue&type=script&lang=js&"
export * from "./OpinionPublishProcess.vue?vue&type=script&lang=js&"
import style0 from "./OpinionPublishProcess.vue?vue&type=style&index=0&id=7c5229ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5229ad",
  null
  
)

export default component.exports